// AnlikOdemeBasarisiz.js
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Badge,
    Alert
} from "reactstrap";
import { checkPaymentFallback } from "../../../api/requests/payment-requests";

const AnlikOdemeBasarisiz = () => {
    const [searchParams] = useSearchParams();
    const [merchantOid, setMerchantOid] = useState("");
    const [isAlreadyUsed, setIsAlreadyUsed] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isInvalidMerchantOid, setIsInvalidMerchantOid] = useState(false);
    const [failMessage, setFailMessage] = useState("");
    const [failCode, setFailCode] = useState("");

    useEffect(() => {
        const oid = searchParams.get("merchant_oid");
        if (oid) {
            setMerchantOid(oid);
            checkUrlStatus(oid);
        } else {
            setLoading(false);
            setIsInvalidMerchantOid(true);
        }
        document.title = "Ödeme Başarısız - Tahsilat360";
    }, [searchParams]);

    useEffect(() => {
        const id = "payment-failed-mobile-styles";
        if (!document.getElementById(id)) {
            const style = document.createElement("style");
            style.id = id;
            style.innerHTML = `
:root { --pf-safe-top: env(safe-area-inset-top, 16px); }
.payment-failed-wrapper { padding-top: var(--pf-safe-top); }
@media (max-width: 576px){
  .payment-failed-card .card-body { padding: 1.25rem !important; padding-top: 4.5rem !important; }
  .payment-failed-icon { width: 72px !important; height: 72px !important; margin-top: 36px !important; }
  .payment-failed-icon i { font-size: 36px !important; }
  .status-badge { font-size: 14px !important; padding: 0.5rem 0.75rem !important; }
}
            `;
            document.head.appendChild(style);
        }
    }, []);


    useEffect(() => {
        const oid = searchParams.get("merchant_oid");
        const message = searchParams.get("fail_message"); // <-- YENİ EKLENDİ
        const code = searchParams.get("fail_code"); // Banka hata kodu (ör. QNB ProcReturnCode)

        if (message) {
            setFailMessage(decodeURIComponent(message)); // <-- YENİ EKLENDİ
        }

        if (code) {
            setFailCode(decodeURIComponent(code));
        }

        if (oid) {
            setMerchantOid(oid);
            checkUrlStatus(oid);
        } else {
            setLoading(false);
            setIsInvalidMerchantOid(true);
        }
        document.title = "Ödeme Başarısız - Tahsilat360";
    }, [searchParams]);

    const checkUrlStatus = async (merchantOid) => {
        try {
            setLoading(true);

            // URL durumunu kontrol et
            const checkResponse = await checkPaymentFallback(merchantOid);
            const checkData = await checkResponse.json();

            if (!checkResponse.ok) {
                // 404 veya diğer hata durumları - geçersiz merchant OID
                setIsInvalidMerchantOid(true);
                return;
            }

            if (checkData.data === true) {
                // Bu URL daha önce kullanılmış
                setIsAlreadyUsed(true);
            } else {
                // URL ilk defa kullanılıyor, başarısız olarak işaretle
                setIsAlreadyUsed(false);
            }
        } catch (error) {
            console.error('URL durumu kontrol hatası:', error);
            setIsInvalidMerchantOid(true);
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            // Optional: Add toast notification here
        });
    };

    // Loading durumu
    if (loading) {
        return (
            <div
                className="min-vh-100 d-flex align-items-center justify-content-center payment-failed-wrapper"
                style={{
                    background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
                    paddingTop: "env(safe-area-inset-top)"
                }}
            >
                <div className="text-center text-white">
                    <div className="spinner-border mb-3" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                    <p>URL durumu kontrol ediliyor...</p>
                </div>
            </div>
        );
    }

    // Geçersiz merchant OID durumu
    if (isInvalidMerchantOid) {
        return (
            <div
                className="min-vh-100 d-flex align-items-center justify-content-center payment-failed-wrapper"
                style={{
                    background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
                    paddingTop: "env(safe-area-inset-top)"
                }}
            >
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8} sm={10}>
                            <Card className="border-0 shadow-lg" style={{ borderRadius: "20px" }}>
                                <CardBody className="p-5 text-center">
                                    <Alert color="danger" className="border-0 mb-4">
                                        <h4 className="alert-heading">Hata!</h4>
                                        <p className="mb-0">Geçersiz işlem numarası veya ödeme bulunamadı.</p>
                                    </Alert>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center payment-failed-wrapper"
            style={{
                background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
            }}
        >
            <Container className="px-3 px-sm-0">
                <Row className="justify-content-center">
                    <Col lg={6} md={8} sm={10}>
                        <Card
                            className="border-0 shadow-lg payment-failed-card"
                            style={{
                                borderRadius: "20px",
                                overflow: "hidden"
                            }}
                        >
                            <CardBody className="text-center p-4 p-sm-5">
                                {/* Error Icon */}
                                <div
                                    className="d-flex align-items-center justify-content-center mb-4 mx-auto payment-failed-icon mt-4 mt-sm-0"
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                        background: isAlreadyUsed
                                            ? "linear-gradient(135deg, #ff9800, #f57c00)"
                                            : "linear-gradient(135deg, #ff6b6b, #ee5a24)",
                                        borderRadius: "50%",
                                        boxShadow: isAlreadyUsed
                                            ? "0 10px 30px rgba(255, 152, 0, 0.3)"
                                            : "0 10px 30px rgba(255, 107, 107, 0.3)"
                                    }}
                                >
                                    <i
                                        className={`bx ${isAlreadyUsed ? 'bx-info-circle' : 'bx-x'} text-white`}
                                        style={{ fontSize: "48px" }}
                                    ></i>
                                </div>

                                {/* Error/Warning Alert */}
                                <Alert
                                    color={isAlreadyUsed ? "warning" : "danger"}
                                    className="border-0 mb-4 mt-4 mt-sm-0"
                                >
                                    <div className="d-flex align-items-center justify-content-center">
                                        <i
                                            className={`bx ${isAlreadyUsed ? 'bx-info-circle' : 'bx-error-circle'} me-2`}
                                            style={{ fontSize: "24px" }}
                                        ></i>
                                        <div>
                                            <h4 className="alert-heading mb-1">
                                                {isAlreadyUsed ? "URL Daha Önce Kullanılmış!" : "Ödeme Başarısız!"}
                                            </h4>
                                            <p className="mb-0">
                                                {isAlreadyUsed
                                                    ? "Bu hata sayfası daha önce görüntülenmiş"
                                                    : "İşleminiz tamamlanamadı"
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </Alert>

                                {/* Description */}
                                <div className="mb-4">
                                    <p
                                        className="text-muted mb-0"
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "1.6"
                                        }}
                                    >
                                        {isAlreadyUsed
                                            ? "Bu hata sayfası daha önce görüntülenmiş olduğu için tekrar yönlendirme yapılmamıştır..."
                                            : failMessage || "Üzgünüz, ödeme işleminiz tamamlanamadı. Lütfen bilgilerinizi kontrol edip tekrar deneyiniz."
                                        }
                                    </p>
                                </div>

                                {/* Transaction Details Card */}
                                <Card className="border-0 bg-light mb-4">
                                    <CardBody className="p-4">
                                        <div className="mb-3">
                                            <h6 className="text-muted mb-2">
                                                <i className="bx bx-receipt me-2"></i>
                                                İşlem Detayları
                                            </h6>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label text-muted small mb-1">İşlem Numarası</label>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <Badge
                                                    color={isAlreadyUsed ? "warning" : "danger"}
                                                    className="px-3 py-2 me-2"
                                                    style={{
                                                        fontSize: "14px",
                                                        fontFamily: "'Courier New', monospace"
                                                    }}
                                                >
                                                    {merchantOid || "Bilinmiyor"}
                                                </Badge>
                                                {merchantOid && (
                                                    <Button
                                                        color={isAlreadyUsed ? "outline-warning" : "outline-danger"}
                                                        size="sm"
                                                        onClick={() => copyToClipboard(merchantOid)}
                                                        title="İşlem Numarasını Kopyala"
                                                    >
                                                        <i className="bx bx-copy"></i>
                                                    </Button>
                                                )}
                                            </div>
                                        </div>

                                        {!isAlreadyUsed && failCode && (
                                            <div className="mb-3">
                                                <label className="form-label text-muted small mb-1">Hata Kodu</label>
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <Badge
                                                        color="danger"
                                                        className="px-3 py-2"
                                                        style={{
                                                            fontSize: "14px",
                                                            fontFamily: "'Courier New', monospace"
                                                        }}
                                                    >
                                                        {failCode}
                                                    </Badge>
                                                </div>
                                            </div>
                                        )}

                                        <div className="mb-0">
                                            <label className="form-label text-muted small mb-1">İşlem Tarihi</label>
                                            <div className="text-dark">
                                                <i className="bx bx-time-five me-2"></i>
                                                {new Date().toLocaleDateString("tr-TR", {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                })}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>

                                {/* Status Badge */}
                                <div className="mb-4">
                                    <Badge
                                        color={isAlreadyUsed ? "warning" : "danger"}
                                        className="px-4 py-3 status-badge"
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            borderRadius: "25px"
                                        }}
                                    >
                                        <i className={`bx ${isAlreadyUsed ? 'bx-info-circle' : 'bx-x-circle'} me-2`}></i>
                                        {isAlreadyUsed ? "URL Daha Önce Kullanılmış" : "Ödeme Başarısız"}
                                    </Badge>
                                </div>

                                {/* Additional Info for Already Used URL */}
                                {isAlreadyUsed && (
                                    <Alert color="info" className="border-0 mb-4">
                                        <small>
                                            <i className="bx bx-info-circle me-2"></i>
                                            Bu hata sayfası URL'i daha önce kullanılmış ve geçersiz kılınmıştır.
                                            Ödeme durumunuz için destek ekibiyle iletişime geçebilirsiniz.
                                        </small>
                                    </Alert>
                                )}

                                {/* Footer Info */}
                                <div className="mt-4 pt-4 border-top">
                                    <p className="text-muted small mb-0">
                                        <i className="bx bx-shield-check me-2"></i>
                                        {isAlreadyUsed
                                            ? "Bu işlem güvenli SSL bağlantısı ile gerçekleştirilmiştir"
                                            : "Kartınızdan herhangi bir ücret çekilmemiştir"
                                        }
                                    </p>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AnlikOdemeBasarisiz;